<template>
    <div class="title-wrapper">
        <div class="title-inner" :class="{'align-text-center': textAlignCenter}">
            <h2 v-dompurify-html="label">111</h2>

            <slot/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'appContentTile',

        props: {
            label: {
                default: '',
                type: String,
            },
            textAlignCenter: {
                default: false,
                type: Boolean,
            }
        }
    }
</script>

<style lang="scss">
    .title-wrapper {
        border-bottom: 1px solid #dedede;
        margin-bottom: 40px;

        .title-inner {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 30px;

            h2 {
                margin: 0;

                .reserved-icon {
                    font-size: 45px;
                    font-weight: bold;

                    &:after {
                        content: '\00AE';
                        position: absolute;
                    }
                }
            }

            &.align-text-center {
                display: block;

                h2 {
                    text-align: center;
                }
            }
        }
    }
</style>
